















































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDateTime, maskMoney } from '@/utils/common'
import CadastroLayoutEmailStore from '@/components/RemuneracaoMedica/financeiro/Store/CadastroLayoutEmailStore'

@Component
export default class ViewFinanceiroCadastroLayoutEmail extends Vue {
  edit: boolean = false

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadOpenModalCadastro: string = ''
  get loadingOpenModalCadastro() { return this.loadOpenModalCadastro }
  set loadingOpenModalCadastro(value: string) { this.loadOpenModalCadastro = value }

  loadSalvar: boolean = false
  get loadingSalvar() { return this.loadSalvar }
  set loadingSalvar(value: boolean) { this.loadSalvar = value }

  modalEnfileirarRecalculo: boolean = false
  get showModalAddEditLayoutEmail() { return this.modalEnfileirarRecalculo }
  set showModalAddEditLayoutEmail(value: boolean) { this.modalEnfileirarRecalculo = value }

  get getStore() {
    return getModule(CadastroLayoutEmailStore, this.$store)
  }

  get fontePagadoraList() {
    return this.getStore.fontePagadoraList
  }

  get tipoList() {
    return this.getStore.tipoList
  }

  get itemsCadastroLayoutEmail() {
    return this.getStore.layoutEmailList
  }

  get fontePagadora() {
    return this.getStore.fontePagadora
  }

  set fontePagadora(value: string) {
    this.getStore.setFontePagadora(value)
  }

  get tipoNome() {
    return this.getStore.tipoNome
  }

  set tipoNome(value: string) {
    this.getStore.setTipoNome(value)
  }

  get assunto() {
    return this.getStore.assunto
  }

  set assunto(value: string) {
    this.getStore.setEmailAssunto(value)
  }

  get emailResposta() {
    return this.getStore.emailResposta
  }

  set emailResposta(value: string) {
    this.getStore.setEmailResposta(value)
  }

  get emailContato() {
    return this.getStore.emailContato
  }

  set emailContato(value: string) {
    this.getStore.setEmailContato(value)
  }

  get emailCorpo() {
    return this.getStore.emailCorpo
  }

  set emailCorpo(value: string) {
    this.getStore.setEmailCorpo(value)
  }

  get emailRodape() {
    return this.getStore.emailRodape
  }

  set emailRodape(value: string) {
    this.getStore.setEmailRodape(value)
  }

  get headers() {
    return [
      { text: 'Nome hospital', value: 'nomeHospital', align: 'center', sortable: false },
      { text: 'Tipo notificação', value: 'tipoNome', align: 'center', sortable: false },
      { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  async openModalCadastro(item: any, action: string) {
    this.loadingOpenModalCadastro = item.hospitalId
    if (action === 'edit') {
      this.getStore.setFontePagadora(item.nomeHospital)
      this.getStore.setTipoNome(item.tipoNome)
      this.edit = true
      const params: any = {
        hospitalId: item.hospitalId,
        tipoNome: item.tipoNome.key,
      }
      await this.getStore.getLayoutEmailById(params)
    }
    this.showModalAddEditLayoutEmail = true
    this.loadingOpenModalCadastro = ''
  }


  async salvarLayoutEmail() {
    this.loadingSalvar = true
    if (this.edit) {
      await this.getStore.salvarLayoutEmail()
    } else {
      await this.getStore.criarLayoutEmail()
    }
    await this.getStore.getLayoutEmailList()
    this.showModalAddEditLayoutEmail = false
    this.loadingSalvar = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    await this.getStore.getLayoutEmailList()
    await this.getStore.getFontePagadoraList()
    await this.getStore.getTipoList()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  maskDateTime(value) {
    return maskDateTime(value)
  }

  @Watch('showModalAddEditLayoutEmail')
  onShowModalAddEditLayoutEmail(value: boolean) {
    if (!value) {
      this.getStore.clearModalAddEdit()
      this.edit = false
    }
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getTotal / this.getStore.qtdPorPagina)
  }

  get getTotal() {
    return this.getStore.totalItems || 0
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getStore.pagina
  }

  set getPagina(value: number) {
    this.getStore.setPagina(value)
  }
}
